import { GET_MARKET_CONFIG_CONTENT } from '../../constants';
export default function getMarketConfigContentCall(payload) {
    return {
        type: GET_MARKET_CONFIG_CONTENT,
        payload,
    };
}
